import React, { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";
import { Lock, Mail, ArrowRight } from "lucide-react";
import { toast, Toaster } from "sonner";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  if (user) return <Navigate to="/admin" replace />;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Bem-vinda, Cristina!");
      navigate("/admin", { replace: true });
    } catch (err) {
      const msg = formatApiErrorDetail(err.response?.data?.detail) || "Erro ao entrar";
      setError(msg);
      toast.error(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="page-admin-login" className="min-h-screen bg-[#F5F5ED] flex items-center justify-center px-6">
      <Toaster position="top-right" richColors />
      <div className="w-full max-w-md bg-white rounded-3xl p-10 soft-shadow border border-[#8BA88E]/15">
        <p className="text-eyebrow text-center">Área restrita</p>
        <h1 className="font-serif text-3xl text-center text-[#2C352D] mt-3">Acessar painel</h1>
        <p className="text-[#5B685C] font-light text-center mt-3">
          Entre para gerenciar artigos, depoimentos e mensagens.
        </p>

        <form onSubmit={handleSubmit} className="mt-8 space-y-5">
          <div>
            <label className="text-sm text-[#5B685C] font-medium">E-mail</label>
            <div className="mt-2 relative">
              <Mail size={16} className="absolute left-4 top-1/2 -translate-y-1/2 text-[#8BA88E]" />
              <input
                data-testid="admin-login-email"
                required
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full rounded-xl border border-[#8BA88E]/30 bg-[#FAF9F6] pl-11 pr-4 py-3 outline-none focus:border-[#8BA88E] focus:ring-2 focus:ring-[#8BA88E]/20 font-light"
              />
            </div>
          </div>
          <div>
            <label className="text-sm text-[#5B685C] font-medium">Senha</label>
            <div className="mt-2 relative">
              <Lock size={16} className="absolute left-4 top-1/2 -translate-y-1/2 text-[#8BA88E]" />
              <input
                data-testid="admin-login-password"
                required
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full rounded-xl border border-[#8BA88E]/30 bg-[#FAF9F6] pl-11 pr-4 py-3 outline-none focus:border-[#8BA88E] focus:ring-2 focus:ring-[#8BA88E]/20 font-light"
              />
            </div>
          </div>
          {error && (
            <p data-testid="admin-login-error" className="text-sm text-red-600">
              {error}
            </p>
          )}
          <button
            data-testid="admin-login-submit"
            disabled={loading}
            type="submit"
            className="btn-primary w-full disabled:opacity-60"
          >
            {loading ? "Entrando..." : "Entrar"} <ArrowRight size={16} />
          </button>
        </form>
      </div>
    </div>
  );
}
